module.exports = __webpack_public_path__ + "85f85e2411d793a772a56bcf87e3e4aa.svg";